import React from 'react';
import { useAppDispatch } from '../../../redux/hooks';
import { closeModal } from '../../../redux/slices/modal';
import { useChartContext } from '../ChartContext';
import { assertNotNil } from '../../../utils/types';
import ShowSqlModalDisplay from './ShowSqlModalDisplay';

const ShowSQLModal = () => {
  const dispatch = useAppDispatch();

  const {
    metadata: { display, referenceSql },
  } = useChartContext();
  assertNotNil(referenceSql);

  const handleClose = () => {
    dispatch(closeModal());
  };

  return (
    <ShowSqlModalDisplay
      sqlType={'Report'}
      close={handleClose}
      headerDisplay={display}
      referenceSql={referenceSql}
    />
  );
};

export default ShowSQLModal;
